import { Typography } from '@chr/eds-react';
import './TrackingInfoItem.scss';
import { Stack } from '@mui/material';
import * as Utilities from '../../utilities/display-utilities';

interface TrackingInfoItemProps {
  /** The text to display the title */
  title: string;
  /** Text to display the information */
  information: string;
  isMobileScreen: boolean;
  isDate?: boolean;
}

export const TrackingInfoItem = ({
  title,
  information,
  isDate,
  isMobileScreen,
}: TrackingInfoItemProps) => {
  return (
    <div
      className={
        isMobileScreen
          ? 'tracking-info-item-container-mobile'
          : 'tracking-info-item-container'
      }
    >
      <Stack
        direction={isMobileScreen ? 'row' : 'column'}
        justifyContent={isMobileScreen ? 'space-between' : 'flex-start'}
        spacing={isMobileScreen ? 2 : 1}
        width={'100%'}
      >
        <Typography variant="body1">{title}</Typography>
        {!isMobileScreen && isDate && (
          <Typography variant="subtitle2">
            {Utilities.formatDateWithAt(information)}
          </Typography>
        )}
        {!isMobileScreen && !isDate && (
          <Typography variant="subtitle2">{information}</Typography>
        )}
        {isMobileScreen && isDate && (
          <Stack direction={'column'} spacing={1} textAlign="right">
            <Typography variant="subtitle2">
              {Utilities.formatDateWithAt(information)}
            </Typography>
            <Typography variant="subtitle2">
              {Utilities.formatTime(information)}
            </Typography>
          </Stack>
        )}
        {isMobileScreen && !isDate && (
          <Stack direction={'row'} spacing={1} textAlign="right">
            <Typography variant="subtitle2">{information}</Typography>
          </Stack>
        )}
      </Stack>
    </div>
  );
};
